/**
 * Пометка перенаправления охраной маршрута по роли (AdminRoute): состояние навигации хранит
 * адрес, закрытый для роли пользователя.
 */

/** Состояние навигации, которым охрана помечает перенаправление по роли */
export interface RoleRedirectState {
	/** Адрес, закрытый для роли пользователя */
	roleRedirectFrom: string;
}

/**
 * Адрес, с которого охрана увела пользователя по роли; null -- переход не от охраны. По нему
 * тур обучения отличает закрытую для роли страницу шага от ухода пользователя со страницы.
 */
export function roleRedirectFrom(state: unknown): string | null {
	if (typeof state !== 'object' || state === null) return null;
	const from = (state as Partial<RoleRedirectState>).roleRedirectFrom;
	return typeof from === 'string' ? from : null;
}
